<template>
  <div class="avatar" :class="size">
    <img :src="img" />
  </div>
</template>
<script>
export default {
  name: 'BaseAvatar',
  props: {
    img: {
      type: String,
      default: '/avatar.png',
    },
    size: {
      // small, medium
      type: String,
      default: 'small',
    },
  },
};
</script>

<style lang="scss" scoped>
.avatar {
  display: flex;
  border-radius: 50%;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0.5rem 1.5rem 0 rgba(37, 44, 97, 0.15), 0 0.2rem 0.4rem 0 rgba(93, 100, 148, 0.2);

  &.small {
    width: 3rem;
    height: 3rem;
  }

  &.medium {
    width: 5rem;
    height: 5rem;
  }

  img {
    width: inherit;
    height: auto;
  }
}
</style>
